var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.433 3.256a4.141 4.141 0 017.798 2.384A4.328 4.328 0 0116 9.676a4.327 4.327 0 01-6.623 3.662A3.486 3.486 0 017.329 14a3.483 3.483 0 01-2.085-.69 3.246 3.246 0 11-3.346-5.507 3.289 3.289 0 013.535-4.547z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjQzMyAzLjI1NmE0LjE0MSA0LjE0MSAwIDAgMSA3Ljc5OCAyLjM4NEE0LjMyOCA0LjMyOCAwIDAgMSAxNiA5LjY3NmE0LjMyNyA0LjMyNyAwIDAgMS02LjYyMyAzLjY2MkEzLjQ4NiAzLjQ4NiAwIDAgMSA3LjMyOSAxNGEzLjQ4MyAzLjQ4MyAwIDAgMS0yLjA4NS0uNjkgMy4yNDYgMy4yNDYgMCAxIDEtMy4zNDYtNS41MDcgMy4yODkgMy4yODkgMCAwIDEgMy41MzUtNC41NDd6Ii8+Cjwvc3ZnPgo=";
export { SvgCloud as ReactComponent };